/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const DELETEEXPERIENCE= createAsyncThunk(
  "deleteExperience/deleteExperience",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteExperienceSlice = createSlice({
  name: "deleteExperienceSlice",
  initialState: {
    deleteExperience: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteExperience: (state) => {
        state.deleteExperience.loading = false
        state.deleteExperience.error = false
        state.deleteExperience.data = []
        state.deleteExperience.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETEEXPERIENCE.fulfilled, (state, action) => {
      state.deleteExperience = {
        ...state.deleteExperience,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEEXPERIENCE.pending, (state, action) => {
      state.deleteExperience = {
        ...state.deleteExperience,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEEXPERIENCE.rejected, (state, action) => {
      state.deleteExperience = {
        ...state.deleteExperience,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteExperienceAction = {
    DELETEEXPERIENCE,
};

export { deleteExperienceAction };
export default deleteExperienceSlice.reducer;
export const {setInitialStateOfdeleteExperience} = deleteExperienceSlice.actions